/**
 * 앱 하단 푸터 컴포넌트
 *
 * 저작권 정보, 시스템명, 관련 링크를 표시한다.
 * useLanguage로 다국어 지원
 */
import React from 'react';
import { Layout, Space, Divider } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import useLanguage from '../../hooks/useLanguage';
import useResponsive from '../../hooks/useResponsive';

const { Footer } = Layout;

// ─── 다국어 텍스트 ─────────────────────────────────────
const TEXTS = {
  ko: {
    mfds: '식품의약품안전처',
    notice: '공지사항',
    guide: '이용안내',
    privacy: '개인정보처리방침',
    systemName: '잔류물질안전정보시스템',
    copyright: 'All rights reserved.',
    address: '충청북도 청주시 흥덕구 오송읍 오송생명2로 187',
    tel: '043-719-1564',
  },
  en: {
    mfds: 'MFDS',
    notice: 'Notices',
    guide: 'User Guide',
    privacy: 'Privacy Policy',
    systemName: 'Residue Safety Info System',
    copyright: 'All rights reserved.',
    address: '187, Osongsaengmyeong 2-ro, Osong-eup, Heungdeok-gu, Cheongju-si',
    tel: '043-719-1564',
  },
};

/**
 * 앱 하단 푸터
 */
const AppFooter = () => {
  const { t } = useLanguage(TEXTS);
  const { isMobile } = useResponsive();
  const currentYear = new Date().getFullYear();

  return (
    <Footer
      style={{
        textAlign: 'center',
        padding: isMobile ? '24px 12px' : '24px',
        paddingBottom: isMobile ? 80 : 24,
        background: '#001529',
        color: 'rgba(255,255,255,0.65)',
        fontSize: 13,
        marginTop: 0,
        borderRadius: 0,
      }}
    >
      {/* 상단 링크 — 한 줄 유지 */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 0,
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        fontSize: isMobile ? 12 : 13,
      }}>
        <a
          href="https://www.mfds.go.kr"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}
        >
          {t.mfds}
        </a>
        <Divider type="vertical" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
        <a href="/doc/prd-board" style={{ color: 'rgba(255,255,255,0.65)' }}>
          {t.notice}
        </a>
        <Divider type="vertical" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
        <span style={{ cursor: 'pointer', color: 'rgba(255,255,255,0.65)' }}>{t.guide}</span>
        <Divider type="vertical" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
        <span style={{ cursor: 'pointer', fontWeight: 500, color: 'rgba(255,255,255,0.65)' }}>{t.privacy}</span>
      </div>

      {/* 주소/연락처 */}
      <div style={{ marginTop: 12, fontSize: isMobile ? 11 : 12, color: 'rgba(255,255,255,0.45)' }}>
        {t.address} | TEL: {t.tel}
      </div>

      {/* 저작권 */}
      <div style={{ marginTop: 8, color: 'rgba(255,255,255,0.45)', fontSize: isMobile ? 11 : 12 }}>
        <SafetyOutlined style={{ marginRight: 4 }} />
        &copy; {currentYear} {t.systemName} v3. {t.copyright}
      </div>
    </Footer>
  );
};

export default AppFooter;
